(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-utilities"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll('.utilities').forEach((el) => observer.observe(el));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initFooter = (root) => {
      root.querySelectorAll('.nomad-footer').forEach((footer) => {
        const inner = footer.querySelector('.nomad-footer__inner');
        if (inner && !inner.classList.contains('is-visible')) {
          if ('IntersectionObserver' in window) {
            const io = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    io.unobserve(entry.target);
                  }
                });
              },
              { threshold: 0.08 }
            );
            io.observe(inner);
          } else {
            inner.classList.add('is-visible');
          }
        }

        footer.querySelectorAll('.nomad-footer__local-form').forEach((form) => {
          if (form.dataset.nfInit) return;
          form.dataset.nfInit = '1';
          const details = form.querySelector('details');
          const input = form.querySelector('input[name="country_code"]');
          if (!details || !input) return;

          form.querySelectorAll('.nomad-footer__country').forEach((btn) => {
            btn.addEventListener('click', () => {
              input.value = btn.dataset.country;
              if (typeof form.requestSubmit === 'function') form.requestSubmit();
              else form.submit();
            });
          });

          document.addEventListener('click', (evt) => {
            if (details.open && !details.contains(evt.target)) details.open = false;
          });

          details.addEventListener('keyup', (evt) => {
            if (evt.key === 'Escape') {
              details.open = false;
              const summary = details.querySelector('summary');
              if (summary) summary.focus();
            }
          });
        });
      });
    };

    const initPops = (root) => {
      root.querySelectorAll('[data-nf-pop]').forEach((trigger) => {
        if (trigger.dataset.nfPopInit) return;
        trigger.dataset.nfPopInit = '1';
        trigger.addEventListener('click', (evt) => {
          const dlg = document.getElementById(trigger.dataset.nfPop);
          // sem <dialog> no navegador, o link original continua valendo
          if (!dlg || typeof dlg.showModal !== 'function') return;
          evt.preventDefault();
          dlg.showModal();
        });
      });

      root.querySelectorAll('.nf-pop').forEach((dlg) => {
        if (dlg.dataset.nfPopInit) return;
        dlg.dataset.nfPopInit = '1';

        // fecha com animacao: o <dialog> sai do DOM no mesmo quadro em que
        // close() e chamado, entao a saida so existe se esperarmos por ela
        const fecharPop = () => {
          if (dlg.dataset.nfClosing) return;
          // mesmo com "reduzir movimento" ha uma saida curta em opacidade,
          // entao nao se fecha mais no seco
          dlg.dataset.nfClosing = '1';
          dlg.classList.add('is-closing');
          const encerrar = () => {
            if (!dlg.dataset.nfClosing) return;
            delete dlg.dataset.nfClosing;
            dlg.classList.remove('is-closing');
            dlg.close();
          };
          const cartao = dlg.querySelector('.nf-pop__card');
          if (cartao) cartao.addEventListener('animationend', encerrar, { once: true });
          setTimeout(encerrar, 400);
        };

        dlg.querySelectorAll('[data-nf-close]').forEach((btn) => {
          btn.addEventListener('click', fecharPop);
        });

        // clique fora do cartao fecha
        dlg.addEventListener('click', (evt) => {
          if (!evt.target.closest('.nf-pop__card')) fecharPop();
        });

        // Esc: segura o fechamento nativo para a animacao caber
        dlg.addEventListener('cancel', (evt) => {
          evt.preventDefault();
          fecharPop();
        });

        dlg.querySelectorAll('[data-nf-copy]').forEach((btn) => {
          btn.addEventListener('click', async () => {
            const texto = btn.getAttribute('data-nf-copy') || '';
            const rotulo = btn.textContent;
            try {
              await navigator.clipboard.writeText(texto);
            } catch (e) {
              const tmp = document.createElement('textarea');
              tmp.value = texto;
              tmp.setAttribute('readonly', '');
              tmp.style.position = 'fixed';
              tmp.style.opacity = '0';
              document.body.appendChild(tmp);
              tmp.select();
              try { document.execCommand('copy'); } catch (e2) {}
              document.body.removeChild(tmp);
            }
            btn.textContent = 'Copiado';
            btn.classList.add('is-copied');
            setTimeout(() => {
              btn.textContent = rotulo;
              btn.classList.remove('is-copied');
            }, 1600);
          });
        });
      });
    };

    const boot = () => { initFooter(document); initPops(document); };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (evt) => {
      initFooter(evt.target);
      initPops(evt.target);
      evt.target.querySelectorAll('.nomad-footer__inner').forEach((el) => el.classList.add('is-visible'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-whatsapp"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      root.querySelectorAll('[data-pp]').forEach((sec) => {
        if (sec.dataset.ppInit) return;
        sec.dataset.ppInit = '1';

        /* ---------- galeria (crossfade + swipe + teclado + zoom) ---------- */
        const stage = sec.querySelector('[data-pp-stage]');
        const thumbs = Array.from(sec.querySelectorAll('[data-pp-thumb]'));
        const slides = Array.from(sec.querySelectorAll('[data-pp-slide]'));
        const count = sec.querySelector('[data-pp-count]');
        let mediaList = [];
        try { mediaList = JSON.parse(sec.querySelector('[data-pp-media]').textContent); } catch (e) {}
        let current = Math.max(0, slides.findIndex((s) => s.classList.contains('is-active')));

        const showSlide = (i) => {
          i = ((parseInt(i, 10) % slides.length) + slides.length) % slides.length;
          if (!slides.length || i === current) return;
          slides.forEach((s, k) => {
            const on = k === i;
            s.classList.toggle('is-active', on);
            s.setAttribute('aria-hidden', on ? 'false' : 'true');
          });
          thumbs.forEach((t, k) => {
            const on = k === i;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
            if (on && typeof t.scrollIntoView === 'function') {
              t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
            }
          });
          if (count) count.textContent = (i + 1) + ' / ' + slides.length;
          current = i;
        };
        thumbs.forEach((t) => t.addEventListener('click', () => showSlide(t.dataset.ppThumb)));
        sec.querySelector('[data-pp-prev]')?.addEventListener('click', (e) => { e.stopPropagation(); showSlide(current - 1); });
        sec.querySelector('[data-pp-next]')?.addEventListener('click', (e) => { e.stopPropagation(); showSlide(current + 1); });

        if (stage) {
          stage.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowRight') { e.preventDefault(); showSlide(current + 1); }
            if (e.key === 'ArrowLeft') { e.preventDefault(); showSlide(current - 1); }
          });
          // swipe: 40px horizontais decidem; vertical continua rolando a pagina.
          // O arraste sobre uma <img> vira drag nativo e engole o pointerup —
          // por isso o dragstart e bloqueado e o ponteiro e capturado no palco.
          stage.addEventListener('dragstart', (e) => e.preventDefault());
          let sx = 0, sy = 0, sw = false;
          const fim = (e) => {
            if (!sw) return; sw = false;
            const dx = e.clientX - sx, dy = e.clientY - sy;
            if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) showSlide(dx < 0 ? current + 1 : current - 1);
          };
          stage.addEventListener('pointerdown', (e) => {
            // setas e lupa tem clique proprio: capturar o ponteiro aqui
            // re-enderecaria o click delas para o palco e abriria o zoom junto
            if ((e.button && e.button !== 0) || e.target.closest('[data-pp-prev],[data-pp-next],[data-pp-zoom]')) { sw = false; return; }
            sx = e.clientX; sy = e.clientY; sw = true;
            try { stage.setPointerCapture(e.pointerId); } catch (err) {}
          });
          stage.addEventListener('pointerup', fim);
          stage.addEventListener('pointercancel', () => { sw = false; });
        }

        // zoom em tela cheia: <dialog> nativo; um toque alterna 1x/2x
        const box = sec.querySelector('[data-pp-lightbox]');
        const boxImg = sec.querySelector('[data-pp-lightbox-img]');
        const openZoom = () => {
          if (!box || !boxImg || typeof box.showModal !== 'function') return;
          const m = mediaList[current] || {};
          boxImg.src = m.src || (slides[current] && slides[current].querySelector('img')?.currentSrc) || '';
          boxImg.alt = m.alt || '';
          box.classList.remove('is-zoomed');
          box.showModal();
        };
        sec.querySelector('[data-pp-zoom]')?.addEventListener('click', (e) => { e.stopPropagation(); openZoom(); });
        if (stage) {
          // clique simples abre o zoom; um swipe (moveu > 8px) nao abre
          let cx = 0, cy = 0;
          stage.addEventListener('pointerdown', (e) => { cx = e.clientX; cy = e.clientY; }, { passive: true });
          stage.addEventListener('click', (e) => {
            if (e.target.closest('[data-pp-prev],[data-pp-next],[data-pp-zoom]')) return;
            if (Math.hypot(e.clientX - cx, e.clientY - cy) > 8) return;
            openZoom();
          });
        }
        if (box) {
          sec.querySelector('[data-pp-lightbox-close]')?.addEventListener('click', () => box.close());
          box.addEventListener('click', (e) => { if (e.target === box) box.close(); });
          boxImg?.addEventListener('click', () => {
            box.classList.toggle('is-zoomed');
            if (box.classList.contains('is-zoomed')) {
              const sc = sec.querySelector('[data-pp-lightbox-scroll]');
              requestAnimationFrame(() => { sc.scrollLeft = (sc.scrollWidth - sc.clientWidth) / 2; sc.scrollTop = (sc.scrollHeight - sc.clientHeight) / 2; });
            }
          });
        }

        /* ---------- variantes ---------- */
        const dataEl = sec.querySelector('[data-pp-variants]');
        let variants = [];
        try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
        const idInput = sec.querySelector('[data-pp-id]');
        const priceEl = sec.querySelector('[data-pp-price]');
        const cardEl = sec.querySelector('[data-pp-card]');
        // interruptor do Pix: o mesmo percentual que o Liquid leu do metafield da loja
        const pixBox = sec.querySelector('.pp__pricebox');
        const PIX_PCT = parseInt((pixBox && pixBox.dataset.ppPixPct) || '0', 10) || 0;
        const PARC_N = Math.max(2, parseInt((pixBox && pixBox.dataset.ppParc) || '2', 10) || 2);
        const addBtn = sec.querySelector('[data-pp-add]');
        const addText = sec.querySelector('[data-pp-add-text]');
        const stockEl = sec.querySelector('[data-pp-stock]');
        const stickyPrice = sec.querySelector('[data-pp-sticky-price]');
        const stickyAdd = sec.querySelector('[data-pp-sticky-add]');
        const selects = sec.querySelectorAll('[data-pp-select]');
        const radios = sec.querySelectorAll('[data-pp-radio]');
        const swatchGroups = sec.querySelectorAll('.pp__swatches');

        const money = (cents) => {
          try {
            // valor redondo sai sem ",00", igual ao money_without_trailing_zeros do Liquid
            const dec = cents % 100 === 0 ? 0 : 2;
            return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'BRL', minimumFractionDigits: dec, maximumFractionDigits: dec }).format(cents / 100);
          } catch (e) { return 'R$ ' + (cents / 100).toFixed(cents % 100 === 0 ? 0 : 2); }
        };

        const chosen = () => {
          const vals = [];
          // ordem das opções pela posição no DOM
          sec.querySelectorAll('[data-pp-option]').forEach((opt) => {
            const sel = opt.querySelector('[data-pp-select]');
            const rad = opt.querySelector('[data-pp-radio]:checked');
            const sw = opt.querySelector('.pp__swatch.is-active');
            if (sel) vals.push(sel.value);
            else if (rad) vals.push(rad.value);
            else if (sw) vals.push(sw.dataset.ppVal);
          });
          return vals;
        };

        const waLink = sec.querySelector('[data-pp-wa]');
        const renderStock = (v) => {
          if (!stockEl) return;
          const dispatch = stockEl.dataset.dispatch || '';
          const prazo = dispatch && v.available ? '<span class="pp__stock-prazo">· ' + dispatch + '</span>' : '';
          if (waLink) {
            // "Verificar estoque": o link fica, so a mensagem muda com a variante escolhida
            const item = v.title && v.title !== 'Default Title' ? waLink.dataset.ppWaTitle + ' (' + v.title + ')' : waLink.dataset.ppWaTitle;
            waLink.href = 'https://wa.me/' + waLink.dataset.ppWaNum + '?text=' + encodeURIComponent((waLink.dataset.ppWaMsg || '').replace('{produto}', item));
            // a bolinha segue a variante: verde com estoque, cinza sem
            const dot = stockEl.querySelector('.pp__dot');
            if (dot) dot.className = 'pp__dot' + (v.available ? '' : ' pp__dot--out');
            stockEl.className = 'pp__stock pp__stock--wa' + (v.available ? '' : ' pp__stock--out');
            const prazoEl = stockEl.querySelector('.pp__stock-prazo');
            if (prazoEl) prazoEl.remove();
            if (prazo) stockEl.insertAdjacentHTML('beforeend', prazo);
            return;
          }
          let cls = 'pp__dot', txt;
          if (!v.available) { cls += ' pp__dot--out'; txt = 'Esgotado no momento'; stockEl.className = 'pp__stock pp__stock--out'; }
          else if (v.inventory_management === 'shopify' && v.inventory_quantity > 0 && v.inventory_quantity <= 5) { cls += ' pp__dot--low'; txt = 'Últimas ' + v.inventory_quantity + ' unidades'; stockEl.className = 'pp__stock pp__stock--low'; }
          else { txt = 'Em estoque'; stockEl.className = 'pp__stock'; }
          stockEl.innerHTML = '<i class="' + cls + '"></i>' + txt + prazo;
        };

        const update = () => {
          const vals = chosen();
          const match = variants.find((v) => {
            const ov = [v.option1, v.option2, v.option3].filter((x) => x != null);
            return ov.length === vals.length && ov.every((x, i) => x === vals[i]);
          });
          if (!match) return;
          if (idInput) idInput.value = match.id;
          const deEl = sec.querySelector('[data-pp-de]');
          if (deEl) {
            if (match.compare_at_price && match.compare_at_price > match.price) {
              deEl.innerHTML = '<span class="visually-hidden">Preço antigo: </span><s>' + money(match.compare_at_price) + '</s>';
              deEl.hidden = false;
            } else {
              deEl.hidden = true;
            }
          }
          if (PIX_PCT > 0) {
            const pix = Math.round(match.price * (100 - PIX_PCT) / 100);
            if (priceEl) priceEl.innerHTML = '<strong>' + money(pix) + '</strong> no Pix <span class="pp__pix-tag">' + PIX_PCT + '% de desconto</span>';
            if (cardEl) cardEl.innerHTML = 'ou <strong>' + money(match.price) + '</strong> em ' + PARC_N + 'x de ' + money(Math.round(match.price / PARC_N)) + ' sem juros no cartão';
            if (stickyPrice) stickyPrice.textContent = money(pix) + ' no Pix';
          } else {
            if (priceEl) priceEl.innerHTML = '<strong>' + money(match.price) + '</strong>';
            if (cardEl) cardEl.innerHTML = 'ou <strong>' + PARC_N + 'x de ' + money(Math.round(match.price / PARC_N)) + '</strong> sem juros no cartão';
            if (stickyPrice) stickyPrice.textContent = money(match.price);
          }
          const label = addBtn ? (addBtn.getAttribute('data-label') || 'Adicionar ao carrinho') : 'Adicionar ao carrinho';
          if (addBtn) {
            addBtn.disabled = !match.available;
            if (addText) addText.textContent = match.available ? label : 'Esgotado';
          }
          if (stickyAdd) { stickyAdd.disabled = !match.available; stickyAdd.textContent = match.available ? 'Adicionar' : 'Esgotado'; }
          renderStock(match);
          // troca imagem se a variante tiver mídia
          if (match.featured_media && typeof match.featured_media.position === 'number') {
            showSlide(match.featured_media.position - 1);
          }
        };

        selects.forEach((s) => s.addEventListener('change', update));
        radios.forEach((r) => r.addEventListener('change', () => {
          const group = r.closest('.pp__cards');
          group?.querySelectorAll('.pp__vcard').forEach((c) => c.classList.toggle('is-active', c.contains(r)));
          update();
        }));
        swatchGroups.forEach((g) => {
          g.querySelectorAll('.pp__swatch').forEach((sw) => {
            sw.addEventListener('click', () => {
              g.querySelectorAll('.pp__swatch').forEach((x) => x.classList.remove('is-active'));
              sw.classList.add('is-active');
              const lbl = sw.closest('.pp__option').querySelector('[data-pp-optval]');
              if (lbl) lbl.textContent = sw.dataset.ppVal;
              update();
            });
          });
        });

        /* ---------- barra fixa (celular) ----------
           A barra precisa estar FORA da secao. O tema poe a classe .wx-reveal
           na <section> com `transform` e `will-change`, e ancestral com
           transform vira o bloco de contencao do position:fixed -- a barra
           deixava de se prender na janela e ficava presa no fim da secao,
           em cima do "Compre tambem". Mudar o CSS nao resolve: qualquer
           ancestral com transform/filter/will-change refaz o estrago. Mover
           para o <body> resolve de uma vez, hoje e no tema que vier. */
        const sticky = sec.querySelector('[data-pp-sticky]');
        if (sticky) {
          // ao re-inicializar (editor de tema), tira a barra que ficou no body
          const antiga = document.querySelector(`body > [data-pp-sticky][data-pp-de="${sec.id}"]`);
          if (antiga && antiga !== sticky) antiga.remove();
          sticky.setAttribute('data-pp-de', sec.id);
          // o --pp-canvas vive na <section>; leva junto, senao a miniatura
          // da barra perde o fundo e cai no valor de reserva
          const canvas = getComputedStyle(sec).getPropertyValue('--pp-canvas');
          if (canvas) sticky.style.setProperty('--pp-canvas', canvas.trim());
          document.body.appendChild(sticky);
        }
        const form = sec.querySelector('#pp-form') || sec.querySelector('form.pp__form');
        if (sticky && addBtn) {
          // liga quando o botao principal ja passou para CIMA da tela
          let ligada = null;
          const confere = () => {
            const on = addBtn.getBoundingClientRect().bottom < 0;
            if (on === ligada) return;
            ligada = on;
            sticky.classList.toggle('is-on', on);
            sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
            // o widget de chat mora no mesmo canto e tem z-index 2147483647:
            // com a barra ligada ele cairia em cima do botao Adicionar. Ele
            // expoe --wx-bottom/--wx-bottom-m como medida oficial, entao a
            // barra so soma a propria altura a essa medida enquanto aparece.
            const chat = document.getElementById('wx-chat');
            if (chat) {
              if (on) {
                const alt = Math.round(sticky.getBoundingClientRect().height) + 12;
                if (!chat.dataset.ppBase) {
                  const cs = getComputedStyle(chat);
                  chat.dataset.ppBase = (cs.getPropertyValue('--wx-bottom').trim() || '40px') + '|' + (cs.getPropertyValue('--wx-bottom-m').trim() || '28px');
                }
                const [b0, m0] = chat.dataset.ppBase.split('|');
                chat.style.setProperty('--wx-bottom', `calc(${b0} + ${alt}px)`);
                chat.style.setProperty('--wx-bottom-m', `calc(${m0} + ${alt}px)`);
              } else if (chat.dataset.ppBase) {
                const [b0, m0] = chat.dataset.ppBase.split('|');
                chat.style.setProperty('--wx-bottom', b0);
                chat.style.setProperty('--wx-bottom-m', m0);
              }
            }
          };
          if ('IntersectionObserver' in window) new IntersectionObserver(confere, { threshold: 0 }).observe(addBtn);
          window.addEventListener('scroll', confere, { passive: true });
          confere();
          stickyAdd?.addEventListener('click', () => {
            if (!form) return;
            if (typeof form.requestSubmit === 'function') form.requestSubmit(addBtn); else addBtn.click();
          });
        }

        /* ---------- descricao longa -> sanfonas pelos <h3> ---------- */
        const desc = sec.querySelector('[data-pp-desc][data-pp-split]');
        if (desc) {
          const body = desc.querySelector('.pp__disc-body');
          const heads = body ? Array.from(body.querySelectorAll(':scope > h3')) : [];
          if (body && heads.length >= 2) {
            const ic = desc.querySelector('.pp__disc-ic');
            let anchor = desc;
            heads.forEach((h) => {
              const det = document.createElement('details');
              det.className = 'pp__disc';
              const title = h.textContent.trim();
              if (/ficha|especifica|t[eé]cnic/i.test(title)) det.classList.add('pp__disc--specs');
              const sum = document.createElement('summary');
              sum.className = 'pp__disc-sum';
              sum.innerHTML = '<span></span>';
              sum.firstChild.textContent = title;
              if (ic) sum.appendChild(ic.cloneNode(true));
              const inner = document.createElement('div');
              inner.className = 'pp__disc-body rte';
              let n = h.nextSibling;
              while (n && !(n.nodeType === 1 && n.tagName === 'H3')) { const nx = n.nextSibling; inner.appendChild(n); n = nx; }
              h.remove();
              det.appendChild(sum); det.appendChild(inner);
              anchor.after(det); anchor = det;
            });
            // se nao sobrou nada antes do primeiro h3, a "Descrição" some
            if (!body.textContent.trim() && !body.querySelector('img,ul,table')) desc.remove();
          }
        }
      });
    };
    const boot = () => init(document);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
